// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2r9PN","content":"LoadingAlert_content__1XOiZ"};